module.exports = __webpack_public_path__ + "img/gyqx2.a263e133.jpg";